import React from "react";

import Chart from "react-google-charts";
import LoadingCenter from "../../LoadingCenter";

import { useQuery } from "@tanstack/react-query";
import { useTheme } from "../../../hooks/useTheme";
import { useHttp } from "../../../hooks/useHttp";

const MonthApprovals = props => {
  const request = useHttp();
  const { theme } = useTheme();
  const { data: graph, isLoading } = useQuery(
    ["graph-month-approvals"],
    () => request({ url: "/dash/graph/3", method: "GET" })
  );

  const bgColor = theme === "dark"
    ? "#323439"
    : "#FFFFFF";

  const textColor = theme === "dark"
    ? "#FFFFFF"
    : "#323439";

  const graphOptions = {
    visibility: "hidden",
    title: "Aprovações - Mês atual",
    titleTextStyle: {
      color: textColor
    },
    legend: {
      textStyle: {
        color: textColor
      }
    },
    vAxis: {
      title: "Aprovações",
      textStyle: {
        color: textColor
      },
      titleTextStyle: {
        color: textColor
      }
    },
    hAxis: {
      title: "Vendedores",
      textStyle: {
        color: textColor
      },
      titleTextStyle: {
        color: textColor
      }
    },
    seriesType: "bars",
    series: { 5: { type: "line" } },
    animation: {
      startup: true,
      easing: "linear",
      duration: 1500,
    },
    backgroundColor: bgColor
  };

  if (isLoading) return <LoadingCenter />;

  return (
    <Chart
      chartType="ComboChart"
      width="100%"
      height="400px"
      data={graph?.data}
      options={graphOptions}
    />
  );
}

export default MonthApprovals;